import { CSSProperties } from 'react';

const mergeTagStyles: CSSProperties = {
    backgroundColor: 'rgba(0, 0, 0, 0.12)',
    borderRadius: '8px',
    padding: '2px 4px',
};

const mergeTagIndicatorStyles: CSSProperties = {
    position: 'absolute',
    opacity: 0,
    // width: 0,
};

const Leaf = ({ attributes, children, leaf }) => {
    const {
        bold,
        italic,
        underline,
        strikethrough,
        code,
        mergedTag,
        mergedTagIndicator,
        ...styles
    } = leaf;

    let style = styles;

    if (bold) {
        children = <strong>{children}</strong>;
    }

    if (italic) {
        children = <em>{children}</em>;
    }

    if (underline) {
        children = <u>{children}</u>;
    }

    if (strikethrough) {
        children = <del>{children}</del>;
    }

    if (code) {
        children = <code>{children}</code>;
    }

    if (mergedTag) {
        style = { ...style, ...mergeTagStyles };
    }

    if (mergedTagIndicator) {
        style = { ...style, ...mergeTagIndicatorStyles };
    }

    return (
        <span {...attributes} style={style}>
            {children}
        </span>
    );
};

export default Leaf;
